/** Twilio <Say> voice / language options for ECX call templates. */
export const CALL_CONTENT_MAX_LENGTH = 2800;

export const CALL_VOICE_OPTIONS = [
    { value: 'Polly.Joanna', label: 'Polly Joanna (US English, Standard)' },
    { value: 'Polly.Matthew', label: 'Polly Matthew (US English, Standard)' },
    { value: 'Polly.Amy', label: 'Polly Amy (UK English, Standard)' },
    { value: 'Polly.Brian', label: 'Polly Brian (UK English, Standard)' },
    { value: 'Polly.Joanna-Neural', label: 'Polly Joanna Neural (US English)' },
    { value: 'Polly.Matthew-Neural', label: 'Polly Matthew Neural (US English)' },
    { value: 'woman', label: 'Basic Woman (free TTS)' },
    { value: 'man', label: 'Basic Man (free TTS)' },
];

export const CALL_LANGUAGE_OPTIONS = [
    { value: 'en-US', label: 'English (United States)' },
    { value: 'en-GB', label: 'English (United Kingdom)' },
    { value: 'en-CA', label: 'English (Canada)' },
    { value: 'en-AU', label: 'English (Australia)' },
    { value: 'fr-CA', label: 'French (Canada)' },
    { value: 'fr-FR', label: 'French (France)' },
    { value: 'es-US', label: 'Spanish (United States)' },
    { value: 'es-ES', label: 'Spanish (Spain)' },
];

export const DEFAULT_CALL_VOICE = 'Polly.Joanna';
export const DEFAULT_CALL_LANGUAGE = 'en-US';
